import './create-alteration-form.scss'

import { cloneDeep } from 'lodash'
import Component from "vue-class-component"
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'

import { Alteration, createTranslatedString } from '@skinsoft/types'
import { ReactiveVue } from "@skinsoft/reactive-vue"
import { EntitySelect } from '@skinsoft/ui'

export const ALTERATION_CREATED = 'global-alteration-created'

@Component({
    components: {
        sEntitySelect: EntitySelect
    },
    props: [],
    template: require('./create-alteration-form.html')
})
export default class CreateAlterationForm extends ReactiveVue {

    private isEditing = false
    private newAlteration: Alteration = {
        typeOfAlteration: '',
        precision: createTranslatedString(this.getAppLocale(), ''),
        media: '',
        drawing: '',
        title: createTranslatedString(this.getAppLocale(), ''),
        detailedViews: [],
    }

    private addIcon = faPlus
    private closeIcon = faTimes

    private toggleEditing() {
        this.isEditing = !this.isEditing
    }

    private onThesaurusTermSelected(entity: any) {
        if(entity.id) {
            this.newAlteration.typeOfAlteration = entity.id
        }
    }

    private onSubmit() {
        this.$emit(ALTERATION_CREATED, cloneDeep(this.newAlteration))
        this.newAlteration = {
            typeOfAlteration: '',
            precision: createTranslatedString(this.getAppLocale(), ''),
            media: '',
            drawing: '',
            title: createTranslatedString(this.getAppLocale(), ''),
            detailedViews: [],
        }
    }
}